import DeleteAppModal from './DeleteAppModal';

export default DeleteAppModal;